import { ApiError } from '@/lib/api';
import type { Papel, Permissao } from '@triade/contracts';

/** Rotulos em portugues das permissoes (so apresentacao; a regra e a API). */
export const ROTULOS_PERMISSAO: Record<Permissao, string> = {
  'custo.ver': 'Ver custos (R$)',
  'preco.ver': 'Ver preços (R$)',
  'precificacao.simular': 'Simular preços',
  'precificacao.gravar': 'Gravar precificação',
  'lista.ver': 'Ver lista de preços',
  'praticado.gravar': 'Gravar preço praticado',
  'margens.ver': 'Ver painel de margens',
  'orcamento.ver': 'Ver orçamentos',
  'orcamento.verTodos': 'Ver orçamentos de todos',
  'orcamento.editar': 'Criar e editar orçamentos',
  'cliente.ver': 'Ver clientes',
  'cliente.editar': 'Editar clientes',
  'item.ver': 'Ver produtos e serviços',
  'item.editar': 'Editar produtos e serviços',
  'tributo.editar': 'Editar tributos',
  'custoAquisicao.editar': 'Editar custo de aquisição',
  'ficha.ver': 'Ver fichas técnicas',
  'ficha.editar': 'Editar fichas técnicas',
  'tabela.ver': 'Ver tabelas de preço',
  'tabela.editar': 'Editar tabelas de preço',
  'empresa.ver': 'Ver dados da empresa',
  'empresa.editar': 'Editar dados da empresa',
  'parametros.ver': 'Ver parâmetros',
  'parametros.editar': 'Editar parâmetros',
  'centro.ver': 'Ver centros de custo',
  'centro.editar': 'Editar centros de custo',
  'cpm.ver': 'Ver custo por minuto',
  'cpm.editar': 'Editar custo por minuto',
  'lote.ver': 'Ver atualizações de custo',
  'lote.decidir': 'Decidir atualizações de custo',
  'marca.dispensar': 'Dispensar marca de custo',
  'onboarding.executar': 'Executar onboarding',
  'usuarios.gerenciar': 'Gerenciar usuários e acessos',
  'auditoria.ver': 'Ver auditoria',
  'rh.ver': 'Ver RH',
  'rh.editar': 'Editar RH',
  'rateio.ver': 'Ver rateios',
  'rateio.editar': 'Editar rateios',
  'pessoal.ver': 'Ver pessoal (salários)',
  'lucro.ver': 'Ver lucro (%, MC, meta e mínimo)',
  'carteira.ver': 'Ver carteira de pedidos',
  'carteira.verTodos': 'Ver carteira de todos',
  'carteira.editar': 'Editar carteira',
  'plano.ver': 'Ver plano de vendas',
  'plano.editar': 'Editar plano de vendas',
  'empresas.gerenciar': 'Gerenciar empresas',
  'perfis.gerenciar': 'Gerenciar perfis de acesso',
  'tenants.gerenciar': 'Gerenciar tenants (consultorias)',
  'integracoes.gerenciar': 'Gerenciar integrações (ERP)',
};

export function rotuloPermissao(permissao: Permissao): string {
  return ROTULOS_PERMISSAO[permissao] ?? permissao;
}

/** Mensagem da API (ex.: PERFIL_EM_USO) tal como veio; sem resposta da API, aviso generico. */
export function mensagemErro(erro: unknown, padrao = 'Não foi possível concluir. Tente de novo.'): string {
  if (!(erro instanceof ApiError)) return 'Falha de comunicação com a API.';
  return erro.message || padrao;
}

/** Representante nunca ve lucro (docs/PERMISSOES.md secao 11): a tela nao oferece a marcacao; a API tambem nega. */
export function bloqueadaPeloPapel(permissao: Permissao, baseadoEm: Papel): boolean {
  return baseadoEm === 'REPRESENTANTE' && permissao === 'lucro.ver';
}

/** Subconjunto das permissoes do padrao que quem consulta pode marcar (copia pre-marcada). */
export function marcaveisDoPadrao(permissoes: readonly Permissao[], concediveis: readonly Permissao[]): Permissao[] {
  const pode = new Set(concediveis);
  return permissoes.filter((p) => pode.has(p));
}
